import React from 'react';
import { Column, Heading, Stack, Row } from '@grubhubprod/gh-cookbook-react';
import { EmployeeInfoField } from 'src/components/enterprise/features/Employee/EmployeeDetailsPage/components/EmployeeDetailsWrapper/EmployeeDetailsInfo/EmployeeInfoField';
import { EmployeeInfo } from 'src/components/enterprise/features/Employee/EmployeeDetailsPage/components/EmployeeDetailsWrapper/EmployeeDetailsInfo/functions/employeeDetailsInfo.utils';

export interface EmployeeDetailsInfoProps {
  employeeInfo: EmployeeInfo | null;
}

export const EmployeeDetailsInfo: React.FC<EmployeeDetailsInfoProps> = ({
  employeeInfo: { name, email, id, role, allocations, department, location },
}) => {
  return (
    <>
      <Stack y="sm">
        <Heading variant="h4">{name}</Heading>
      </Stack>
      <Row>
        <Column phone={12}>
          <EmployeeInfoField label="Email" value={email} />
        </Column>
        {id && (
          <Column phone={12}>
            <EmployeeInfoField label="ID" value={id} />
          </Column>
        )}
        <Column phone={12}>
          <EmployeeInfoField label="Role" value={role} />
        </Column>
        {allocations && (
          <Column phone={12}>
            <EmployeeInfoField label="Allocations" value={allocations} />
          </Column>
        )}
        {department && (
          <Column phone={12}>
            <EmployeeInfoField label="Department" value={department} />
          </Column>
        )}
        {location && (
          <Column phone={12}>
            <EmployeeInfoField label="Location" value={location} />
          </Column>
        )}
      </Row>
    </>
  );
};
